module.exports = __webpack_public_path__ + "static/home_item_b_2s-d7cbc3a62d868892ade94a8969e90a45.mp4";